<div class="general-alert" *ngIf="!closed">
  <div class="general-alert__close" (click)="close()">&#215;</div>
  <!-- <div class="general-alert__logo">
    <img src="assets/imgs/funz-general-logo.png"/>
  </div> -->
  <div [innerHTML]="msg"></div>
</div>